module.exports = __webpack_public_path__ + "media/images/event/bg-03225026f662ef5fc63b646559c0d32c.png";